export const factoryProducts = [
  {
    id: 1,
    sellerName: "Guangzhou SunTex Garment Factory",
    sellerAvatar: "https://public.readdy.ai/ai/img_res/87348cf31cdf5c8973a226d386dffcf0.jpg",
    country: "China",
    flag: "🇨🇳",
    verified: true,
    category: "Apparel & Textiles",
    productName: "Custom Printed T-Shirts (MOQ 100pcs)",
    description: "High-quality 100% cotton custom printed t-shirts. Available in all sizes S-3XL. Full-color DTG or screen printing. Fast turnaround 7-14 days.",
    images: [
      "https://readdy.ai/api/search-image?query=custom%20printed%20t-shirts%20colorful%20fashion%20apparel%20factory%20production%20clean%20white%20background%20professional%20product%20photography&width=400&height=300&seq=fp1a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=cotton%20t-shirt%20bulk%20wholesale%20garment%20factory%20stack%20folded%20clean%20minimal%20background&width=400&height=300&seq=fp1b&orientation=landscape",
    ],
    priceList: [
      { qty: "100–499 pcs", price: "$4.50/pc" },
      { qty: "500–999 pcs", price: "$3.20/pc" },
      { qty: "1000+ pcs", price: "$2.10/pc" },
    ],
    minOrder: "100 pcs",
    leadTime: "7–14 days",
    whatsapp: "+86 138 0000 1234",
    email: "sales@suntexgarment.com",
    rating: 4.8,
    reviews: 312,
    tags: ["OEM", "Custom Label", "Fast Ship"],
  },
  {
    id: 2,
    sellerName: "Shenzhen ElecPro Technology Co.",
    sellerAvatar: "https://readdy.ai/api/search-image?query=professional%20Chinese%20tech%20entrepreneur%20portrait%20business%20confident%20clean%20background&width=80&height=80&seq=fav2&orientation=squarish",
    country: "China",
    flag: "🇨🇳",
    verified: true,
    category: "Electronics",
    productName: "Wireless Bluetooth Earbuds TWS (OEM)",
    description: "Premium TWS earbuds with ANC, 30hr battery life, IPX5 waterproof. Custom branding available. CE/FCC certified. Ready for Amazon/Shopify.",
    images: [
      "https://readdy.ai/api/search-image?query=wireless%20bluetooth%20earbuds%20TWS%20white%20clean%20product%20photography%20minimal%20background%20professional&width=400&height=300&seq=fp2a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=earbuds%20charging%20case%20open%20electronics%20product%20white%20background%20studio%20shot&width=400&height=300&seq=fp2b&orientation=landscape",
    ],
    priceList: [
      { qty: "50–199 units", price: "$12.80/unit" },
      { qty: "200–499 units", price: "$9.50/unit" },
      { qty: "500+ units", price: "$7.20/unit" },
    ],
    minOrder: "50 units",
    leadTime: "10–20 days",
    whatsapp: "+86 135 8888 5678",
    email: "oem@elecpro.cn",
    rating: 4.9,
    reviews: 487,
    tags: ["CE Certified", "OEM/ODM", "Amazon Ready"],
  },
  {
    id: 3,
    sellerName: "Vietnam Bamboo Craft Export",
    sellerAvatar: "https://readdy.ai/api/search-image?query=Vietnamese%20artisan%20craftsman%20portrait%20professional%20smiling%20clean%20background&width=80&height=80&seq=fav3&orientation=squarish",
    country: "Vietnam",
    flag: "🇻🇳",
    verified: true,
    category: "Home & Decor",
    productName: "Handmade Bamboo Home Decor Set",
    description: "Eco-friendly handcrafted bamboo furniture and decor. Baskets, trays, lamp shades, wall art. Sustainable sourcing, export-ready packaging.",
    images: [
      "https://readdy.ai/api/search-image?query=handmade%20bamboo%20home%20decor%20set%20eco%20friendly%20natural%20craft%20products%20clean%20white%20background%20studio&width=400&height=300&seq=fp3a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=bamboo%20basket%20tray%20lamp%20shade%20wall%20art%20natural%20eco%20decor%20minimal%20background&width=400&height=300&seq=fp3b&orientation=landscape",
    ],
    priceList: [
      { qty: "20–99 sets", price: "$18.00/set" },
      { qty: "100–299 sets", price: "$13.50/set" },
      { qty: "300+ sets", price: "$10.00/set" },
    ],
    minOrder: "20 sets",
    leadTime: "14–21 days",
    whatsapp: "+84 90 123 4567",
    email: "export@vietnambamboo.vn",
    rating: 4.7,
    reviews: 198,
    tags: ["Eco-Friendly", "Handmade", "Export Ready"],
  },
  {
    id: 4,
    sellerName: "India Spice & Food Exports Ltd.",
    sellerAvatar: "https://readdy.ai/api/search-image?query=Indian%20business%20owner%20professional%20portrait%20confident%20clean%20background&width=80&height=80&seq=fav4&orientation=squarish",
    country: "India",
    flag: "🇮🇳",
    verified: true,
    category: "Food & Agriculture",
    productName: "Premium Organic Spice Collection",
    description: "USDA & EU organic certified spices: turmeric, cumin, cardamom, black pepper, coriander. Bulk and retail packaging available. HACCP certified facility.",
    images: [
      "https://readdy.ai/api/search-image?query=organic%20spices%20collection%20turmeric%20cumin%20cardamom%20colorful%20bowls%20clean%20white%20background%20professional%20food%20photography&width=400&height=300&seq=fp4a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=bulk%20spice%20packaging%20bags%20export%20food%20grade%20clean%20minimal%20background&width=400&height=300&seq=fp4b&orientation=landscape",
    ],
    priceList: [
      { qty: "50–199 kg", price: "$8.50/kg" },
      { qty: "200–499 kg", price: "$6.80/kg" },
      { qty: "500+ kg", price: "$5.20/kg" },
    ],
    minOrder: "50 kg",
    leadTime: "5–10 days",
    whatsapp: "+91 98765 43210",
    email: "trade@indiaspiceexport.com",
    rating: 4.6,
    reviews: 256,
    tags: ["USDA Organic", "HACCP", "Bulk Available"],
  },
  {
    id: 5,
    sellerName: "Turkey Leather Goods Factory",
    sellerAvatar: "https://readdy.ai/api/search-image?query=Turkish%20factory%20manager%20professional%20portrait%20business%20clean%20background&width=80&height=80&seq=fav5&orientation=squarish",
    country: "Turkey",
    flag: "🇹🇷",
    verified: true,
    category: "Leather & Accessories",
    productName: "Genuine Leather Bags & Wallets (OEM)",
    description: "Premium full-grain leather handbags, wallets, belts. Custom logo embossing, color matching. EU export compliant. Luxury retail quality at factory price.",
    images: [
      "https://readdy.ai/api/search-image?query=genuine%20leather%20handbag%20wallet%20belt%20luxury%20fashion%20accessories%20clean%20white%20background%20professional%20product%20photography&width=400&height=300&seq=fp5a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=leather%20goods%20collection%20brown%20tan%20luxury%20accessories%20minimal%20clean%20background%20studio&width=400&height=300&seq=fp5b&orientation=landscape",
    ],
    priceList: [
      { qty: "30–99 pcs", price: "$28.00/pc" },
      { qty: "100–299 pcs", price: "$21.00/pc" },
      { qty: "300+ pcs", price: "$16.50/pc" },
    ],
    minOrder: "30 pcs",
    leadTime: "15–25 days",
    whatsapp: "+90 532 000 1234",
    email: "oem@turkeyleather.com",
    rating: 4.8,
    reviews: 143,
    tags: ["Full-Grain Leather", "Custom Logo", "EU Compliant"],
  },
  {
    id: 6,
    sellerName: "Brazil Furniture & Wood Works",
    sellerAvatar: "https://readdy.ai/api/search-image?query=Brazilian%20furniture%20craftsman%20professional%20portrait%20smiling%20clean%20background&width=80&height=80&seq=fav6&orientation=squarish",
    country: "Brazil",
    flag: "🇧🇷",
    verified: true,
    category: "Furniture & Wood",
    productName: "Solid Hardwood Dining Table Sets",
    description: "Sustainably sourced Brazilian hardwood dining sets. Custom sizes, finishes, and upholstery. FSC certified. Container-load pricing available.",
    images: [
      "https://readdy.ai/api/search-image?query=solid%20hardwood%20dining%20table%20set%20furniture%20modern%20clean%20minimal%20white%20background%20professional%20product%20photography&width=400&height=300&seq=fp6a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=wood%20furniture%20dining%20chairs%20table%20natural%20grain%20finish%20clean%20studio%20background&width=400&height=300&seq=fp6b&orientation=landscape",
    ],
    priceList: [
      { qty: "5–19 sets", price: "$420/set" },
      { qty: "20–49 sets", price: "$340/set" },
      { qty: "50+ sets", price: "$280/set" },
    ],
    minOrder: "5 sets",
    leadTime: "21–35 days",
    whatsapp: "+55 11 9 8765 4321",
    email: "export@brazilwood.com.br",
    rating: 4.7,
    reviews: 89,
    tags: ["FSC Certified", "Custom Size", "Container Load"],
  },
  {
    id: 7,
    sellerName: "Pakistan Sports Goods Manufacturer",
    sellerAvatar: "https://readdy.ai/api/search-image?query=Pakistani%20manufacturer%20professional%20portrait%20business%20confident%20clean%20background&width=80&height=80&seq=fav7&orientation=squarish",
    country: "Pakistan",
    flag: "🇵🇰",
    verified: true,
    category: "Sports & Fitness",
    productName: "Custom Sports Balls & Equipment",
    description: "FIFA/ICC approved sports balls, boxing gloves, gym equipment. Custom branding for clubs and retailers. Sialkot quality — trusted by 50+ countries.",
    images: [
      "https://readdy.ai/api/search-image?query=sports%20balls%20football%20soccer%20boxing%20gloves%20gym%20equipment%20collection%20clean%20white%20background%20professional&width=400&height=300&seq=fp7a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=custom%20branded%20sports%20equipment%20bulk%20wholesale%20clean%20minimal%20background%20studio&width=400&height=300&seq=fp7b&orientation=landscape",
    ],
    priceList: [
      { qty: "100–499 pcs", price: "$6.50/pc" },
      { qty: "500–999 pcs", price: "$4.80/pc" },
      { qty: "1000+ pcs", price: "$3.50/pc" },
    ],
    minOrder: "100 pcs",
    leadTime: "10–18 days",
    whatsapp: "+92 300 1234567",
    email: "sales@sialkotgoods.pk",
    rating: 4.9,
    reviews: 521,
    tags: ["FIFA Approved", "Custom Brand", "50+ Countries"],
  },
  {
    id: 8,
    sellerName: "South Korea Beauty & Skincare OEM",
    sellerAvatar: "https://readdy.ai/api/search-image?query=Korean%20beauty%20brand%20manager%20professional%20portrait%20clean%20background&width=80&height=80&seq=fav8&orientation=squarish",
    country: "South Korea",
    flag: "🇰🇷",
    verified: true,
    category: "Beauty & Cosmetics",
    productName: "K-Beauty Skincare Private Label",
    description: "K-Beauty OEM/ODM skincare: serums, sheet masks, moisturizers, sunscreens. ISO 22716 GMP certified. Custom formulation, packaging design included.",
    images: [
      "https://readdy.ai/api/search-image?query=Korean%20beauty%20skincare%20products%20serum%20moisturizer%20sheet%20mask%20clean%20white%20background%20professional%20product%20photography&width=400&height=300&seq=fp8a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=K-beauty%20cosmetics%20packaging%20bottles%20jars%20minimal%20clean%20white%20background%20studio&width=400&height=300&seq=fp8b&orientation=landscape",
    ],
    priceList: [
      { qty: "200–499 units", price: "$5.80/unit" },
      { qty: "500–999 units", price: "$4.20/unit" },
      { qty: "1000+ units", price: "$3.10/unit" },
    ],
    minOrder: "200 units",
    leadTime: "20–30 days",
    whatsapp: "+82 10 1234 5678",
    email: "oem@kbeautyfactory.kr",
    rating: 4.9,
    reviews: 634,
    tags: ["GMP Certified", "OEM/ODM", "Custom Formula"],
  },
];

export const factoryCategories = [
  "All",
  "Apparel & Textiles",
  "Electronics",
  "Home & Decor",
  "Food & Agriculture",
  "Leather & Accessories",
  "Furniture & Wood",
  "Sports & Fitness",
  "Beauty & Cosmetics",
];
